import { useState } from 'react';
import { useWindowSize } from './useWindowSize.js';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect.js';
import { useTheme } from '@emotion/react';

const getIsMobile = (width, breakpoint) => width ? width <= breakpoint : false;
function useIsMobile() {
  let mobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "auto";
  const windowSize = useWindowSize();

  // Pull from theme breakpoints, check if its using px or rem
  // and convert to number to compare against window width
  const {
    breakpoints
  } = useTheme();
  // Note: If you pass parseInt() a string that starts with numbers but also includes
  // alphabetical characters it will evaluate the numerals and break when it hits the first
  // alpha character. This means that "30rem", "30em", and "30px" all evaluate to 30.
  const mobileBreakpoint = typeof breakpoints[0] === "string" ? breakpoints[0].includes("px") ? parseInt(breakpoints[0], 10) : parseInt(breakpoints[0], 10) * 16 // Handle em and rem
  : breakpoints[0];
  const [isMobile, setIsMobile] = useState(mobile === "auto" ? getIsMobile(windowSize.width, mobileBreakpoint) : mobile);
  useIsomorphicLayoutEffect(() => {
    const newIsMobile = mobile !== "auto" ? mobile : getIsMobile(windowSize.width, mobileBreakpoint);
    setIsMobile(newIsMobile);
  }, [mobile, windowSize, mobileBreakpoint]);
  return isMobile;
}

export { useIsMobile };
